import { useEffect, useState } from "react";
import { FilterMultiDropdown, FilterWithQuickSearch } from "./components";

const Filter = ({
  customDropdownStyleClass = "",
  customDropDownContainerStyleClass = "",
  filterSetup = {},
  filterValue = {},
  filterDefaultValue = {},
  setFilterValue = () => { },
  onReset = () => { },
  onSubmitSearch = () => { },
  setDependency = () => { },
  dependency = {},
  apiValue = {},
  customDropdownTitle = {},
  activeTab = "",
  filterCloseDependency,
}) => {
  const [localFilterValue, setLocalFilterValue] = useState(filterValue);
  const onHandleSubmitFilter = () => {
    setFilterValue({ ...localFilterValue });
    onSubmitSearch();
  };

  useEffect(() => {
    if (localFilterValue !== filterValue) {
      setLocalFilterValue(filterValue);
    }
  }, [filterValue]);

  const renderFilter = () => {
    switch (filterSetup.filter_type) {
      //FILTER TYPE
      //1: With quicksearch
      //2: only dropdowns
      case 1:
        return (
          <FilterWithQuickSearch
            customDropdownStyleClass={customDropdownStyleClass}
            customDropDownContainerStyleClass={customDropDownContainerStyleClass}
            filterSetup={filterSetup}
            localFilterValue={localFilterValue}
            setLocalFilterValue={setLocalFilterValue}
            onSubmitQuickSearch={onHandleSubmitFilter}
            filterDefaultValue={filterDefaultValue}
            onReset={onReset}
            onSubmitSearch={onHandleSubmitFilter}
            activeTab={activeTab}
            apiValue={apiValue}
            setDependency={setDependency}
            dependency={dependency}
          />
        );
      case 2:
        return (
          <FilterMultiDropdown
            customDropdownStyleClass={customDropdownStyleClass}
            customDropDownContainerStyleClass={customDropDownContainerStyleClass}
            customDropdownTitle={customDropdownTitle}
            filterSetup={filterSetup}
            localFilterValue={localFilterValue}
            filterDefaultValue={filterDefaultValue}
            setLocalFilterValue={setLocalFilterValue}
            apiValue={apiValue}
            onReset={onReset}
            onSubmitSearch={onHandleSubmitFilter}
            setDependency={setDependency}
            dependency={dependency}
            activeTab={activeTab}
          />
        );
      default:
        break;
    }
  };
  return renderFilter();
};

export default Filter;
